import './App.css';
import Header from './Header';

function SciencePage() {
  return (
    <div className="science-page">
      <Header dark={false} />

      <section className="science-section">
        <div className="science-section-inner">
          <section className="section-papers">
            <div className="paper-card">
                <div className="paper-card-header">
                <span className="paper-card-journal">Scientific Reports · Nature</span>
                <a
                    href="https://www.nature.com/articles/s41598-021-02214-1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="paper-card-link"
                >
                    Read full paper ↗
                </a>
                </div>
                <div className="paper-card-figure">
                <img src="/images/nature_header.webp" alt="Epitachophoresis of DNA stained with SYBR" width="619" height="377" className="paper-card-img" />
                </div>
                <h3 className="paper-card-title">
                Epitachophoresis is a novel versatile total nucleic acid extraction method
                </h3>
                <div className="paper-card-body">
                <div className="paper-card-abstract">
                    <span className="paper-card-label">Abstract</span>
                    <p>
                    Epitachophoresis is a novel next generation extraction system capable of isolating DNA and RNA simultaneously from clinically relevant samples. Here we build on the versatility of Epitachophoresis by extracting diverse nucleic acids ranging in lengths (20 nt–290 Kbp). The quality of extracted miRNA, mRNA and gDNA was assessed by downstream Next-Generation Sequencing.
                    </p>
                </div>
                </div>
            </div>

            <div className="paper-card">
              <div className="paper-card-header">
                <span className="paper-card-journal">Analytical Chemistry</span>
                <a
                  href="https://pubs.acs.org/doi/abs/10.1021/acs.analchem.8b05860"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="paper-card-link"
                >
                  Read full paper ↗
                </a>
              </div>
              <div className="paper-card-figure">
                <img src="/images/AC_header.webp" alt="Absorbance and fluorescence traces of collected vs. original sample" width="1000" height="538" className="paper-card-img" />
              </div>
              <h3 className="paper-card-title">
                Macrofluidic Device for Preparative Concentration Based on Epitachophoresis
              </h3>
              <div className="paper-card-body">
                <div className="paper-card-abstract">
                  <span className="paper-card-label">Abstract</span>
                  <p>
                    We have developed a new separation device to concentrate and collect ions from several milliliter sample volumes to microliter fractions. Unlike most conventional platforms, this device has circular architecture. The electrophoretic migration operates from the outer perimeter toward the center. Separations can be performed both in continuous (zone electrophoresis) and discontinuous (moving boundary) electrolyte systems. We use a discontinuous electrolyte system comprising a leading and a terminating electrolyte to concentrate samples containing small organic anions and DNA fragment.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <div className="patent-section">
            <h3>Four Patents Granted. Seven Patents Pending.</h3>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SciencePage;
